<script lang="ts" setup>
	import { createReusableTemplate } from '@vueuse/core'

	const { Socials } = useStore()
	const isDialogOpen = shallowRef(false)
	const authMode = shallowRef<'register' | 'login'>('register')
	const openModal = (arg: 'register' | 'login' = 'register') => {
		authMode.value = arg
		isDialogOpen.value = true
	}
	const [defineSocials, useSocials] = createReusableTemplate()
</script>

<template>
	<footer class="md:py-[80px] py-[40px] relative bg-gray-900 overflow-hidden mb-auto">
		<define-socials>
			<div class="items-stretch gap-[12px] md:gap-[16px]">
				<nuxt-link v-for="(item, index) in Socials" :key="index" :to="item.url" target="_blank">
					<tools-icon
						dir="socials"
						:icon="item.iconName"
						svg-class="h-[32px] w-[32px] md:w-[60px] md:h-[60px] fill-white rounded-lg md:rounded-[20px]"
					/>
				</nuxt-link>
			</div>
		</define-socials>
		<ui-pad>
			<div class="wrapper h-[inherit] py-6 sm:pt-14 flex relative z-20 flex-col items-center">
				<ui-wrapper class="mx-auto w-full">
					<div class="md:pb-20 border-b border-gray-500 w-full flex justify-between flex-wrap items-center">
						<div class="lg:space-y-[80.43px] space-y-[32.4px] mb-[32.4px] lg:mb-0 md:mb-[50px]">
							<tools-icon
								dir="internal-logo"
								icon="mcg-logo-mixed"
								width="570"
								height="144"
								svg-class="md:h-[144px] h-[58px] w-[228px] md:w-[570px]"
							/>
							<use-socials class="md:flex hidden" />
						</div>
						<footer-links
							type="campaign"
							class="md:bg-transparent p-[24px_16px] md:p-0 md:w-auto mt-0 mx-0"
							btn-cls="hidden"
							open-default="contact"
							title-wrapper-cls="border-b-0"
							@login="openModal('login')"
						/>
						<use-socials class="md:hidden flex py-[32px]" />
					</div>

					<div
						class="md:pt-16 pt-[32px] w-full flex flex-wrap sm:flex-nowrap items-end justify-between gap-x-8 text-gray-400"
					>
						<p class="sm:max-w-[718px] pb-10 text-sm sm:pb-0">
							Disclaimer: MyCoverGenius is not an insurance company, we partner with leading and regulated
							insurance companies in Nigeria to make insurance affordable and accessible for businesses
						</p>

						<molecules-providers class="sm:mr-auto w-full sm:w-[unset]" />
					</div>
					<p class="text-sm sm:hidden py-5 text-gray-400">
						© {{ new Date().getFullYear() }} | MyCovergenius | All Rights Reserved
					</p>
				</ui-wrapper>
			</div>
		</ui-pad>

		<div class="absolute h-full top-0 lg:top-[unset] lg:bottom-0 pointer-events-none z-[1]">
			<tools-icon
				dir="fill"
				icon="campaign-pattern"
				width="1439"
				height="866"
				class="pointer-event-none"
				svg-class="w-[100vw] h-[100%] absolute -left-[90.66px] md:static -top-[3.15px] block opacity-[0.05]"
			/>
		</div>
		<molecules-auth-dialog v-model="isDialogOpen" :selected="authMode" />
	</footer>
</template>
